import {SupportedLocales} from '@gl/lit/types/locale.js';

export const datasetSelectionOptions = {
  [SupportedLocales.EN]: {
    noDatasetGroupsFound: 'No dataset groups found.',
  },
  [SupportedLocales.ES]: {
    noDatasetGroupsFound: 'No se encontraron grupos de conjuntos de datos”.',
  },
};
